import { useAtomValue } from 'jotai';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import tip from '@/assets/modal/tip.webp';
import { IconMail, IconMyGoldSimple, RoundRs } from '@/components/icons/icons';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import { mailDataAtom } from '@/jotai/mail';
import IconCoinPlus from '@/modules/coin/assets/icon_coin_plus.webp';
import rechargeTip from '@/modules/coin/assets/recharge_tip.webp';
import rechargeTip1 from '@/modules/coin/assets/recharge_tip_1.webp';
import rechargeStore from '@/stores/recharge';
import { globalStore } from '@/stores/store';
import emitter from '@/utils/event-bus';
import { removeTrailingZeros, toFixed } from '@/utils/utils';

import WithdrawScoreModal from '../game/modal-show-score';
import styles from './styles.module.less';

const Coin = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { initialState, initialFreeWithdrawInfo } = globalStore;
  const { vippoint, showWithdrawGuide, isLogin } = initialState;
  const { score_free, score } = initialFreeWithdrawInfo;
  const [hideWithdrawGuide, setShowWithdrawGuide] = useState((window as any)?.hideWithdrawGuide);

  const newAwards = useAtomValue(mailDataAtom);

  const showTip =
    (globalStore?.initialState?.viplevel === 0 || showWithdrawGuide) &&
    !hideWithdrawGuide &&
    isLogin &&
    pathname === '/game';
  const freeCash = useMemo(() => {
    /** 免费提款额
     * i. 用户充值前，展示身金余额
     * ii. 用户充值后，展示免费提款额
     */
    if (vippoint > 0) {
      return removeTrailingZeros(toFixed(score_free));
    }
    return removeTrailingZeros(toFixed(score));
  }, [vippoint, score, score_free]);
  const walletCash = useMemo(() => {
    /** 游戏钱包余额
     *i. 用户充值前，展示为 0
     *ii. 用户充值后，展示身金余额
     */
    if (vippoint > 0) {
      return removeTrailingZeros(toFixed(score));
    }
    return 0;
  }, [vippoint, score]);

  const showCashModal = () => {
    if (globalStore.isTestRechargeViewBetter) {
      // togglePopover();
      emitter.emit('toggleCashModalShow');
      return;
    }

    showNiceModal({
      maskClosable: true,
      render: WithdrawScoreModal
    });
  };

  useEffect(() => {
    emitter.on('cashModalHide', () => setShowWithdrawGuide(false));
    return () => emitter.off('cashModalHide', () => setShowWithdrawGuide(false));
  }, [pathname]);

  const getTipContent = () => {
    if (showWithdrawGuide) {
      return <BlurryLoadingImage src={(window?.imgPrefix || '') + '/img/modal/tip.webp'} style={{ width: '100%' }} />;
    }

    if (rechargeStore.firstRecharge.show) {
      return <BlurryLoadingImage style={{ width: '1.97rem' }} src={rechargeTip} />;
    }

    return <BlurryLoadingImage style={{ width: '1.97rem' }} src={rechargeTip1} />;
  };

  return (
    <div className={styles.container}>
      <div className={styles.amount}>
        <div
          onClick={() => {
            setShowWithdrawGuide(true);
            (window as any).hideWithdrawGuide = true;
            showCashModal();
          }}
        >
          <div className={styles.money}>$ {walletCash}</div>
          <div className={styles.bonus}>
            <IconMyGoldSimple />
            <span>{freeCash}</span>
          </div>
        </div>
        <div
          className={styles.pointer}
          onClick={() => {
            navigate('/recharge');
            implog('plus_icon_click');
          }}
        >
          <BlurryLoadingImage src={IconCoinPlus} />
          {showTip && <div className={styles.tip}>{getTipContent()}</div>}
        </div>
      </div>
      <div className={styles.coins} style={{ flex: 'none', width: '0.6rem', minWidth: 'unset' }}>
        <div
          className={newAwards?.length ? styles.mail_animate_box : styles.mail_box}
          onClick={() => {
            navigate('/mail');
            implog('menu_mail_click');
          }}
        >
          <IconMail className={styles.mail} />
        </div>
      </div>
    </div>
  );
};

export default observer(Coin);
